module.exports = __webpack_public_path__ + "static/img/3.09f902d3.png";